// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-link-wrapper
import Link from 'next/link'
import styled from 'styled-components'

import { Alert, TextLink, TypeStyle } from '@syconium/little-miss-figgy'

interface OrLineProps {
  side: 'left' | 'right'
}

export const OrDivider = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  top: 13px;
`

export const OrLine = styled.div<OrLineProps>`
  flex-grow: 1;
  margin: 0px 0.75px;
  border-top: 1px solid ${o => o.theme.color.deprecated.stoneLight};
  ${props =>
    props.side === 'left' ? 'border-top-left-radius: 4px;' : 'border-top-right-radius: 4px;'}
`

export const OrText = styled(TypeStyle.HeadlineExtraSmall)`
  margin: 0 ${o => o.theme.spacing(4)};
  font-size: 16px;
  white-space: nowrap;
  text-transform: uppercase;
`

export const ExistingLogoContainer = styled.div`
  border: 1px solid ${o => o.theme.color.deprecated.stoneLight};
  border-top: none;
  border-radius: 4px;
  padding: ${o => o.theme.spacing(8)} ${o => o.theme.spacing(6)};
  text-align: center;
`

export const ExistingLogoTitle = styled(TypeStyle.HeadlineExtraSmall)`
  font-size: 16px;
  margin-bottom: ${o => o.theme.spacing(2)};
`

export const ExistingLogoSubtitle = styled(TypeStyle.BodyDefault)`
  line-height: 24px;
  margin-bottom: ${o => o.theme.spacing(3)};
`

export const LoginTextLink = styled(TextLink)`
  font-size: 13px;
  font-weight: ${o => o.theme.typography.font.weight[700]};
  line-height: 20px;
  letter-spacing: 2px;
  border-bottom: 2px solid ${o => o.theme.color.text.primary.on.background};
  padding-bottom: 4px;
  text-transform: uppercase;
`

export const LoginAlert = styled(Alert)``

export const LoginMessage = styled(Alert.Message)`
  color: ${o => o.theme.color.stroke.info.text.on.subtle};
`
export const LoginLink = styled(Link)`
  text-decoration: underline;
`
